import { FORM_TEMPLATES_ACCESS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { FormStatus } from "@/modules/FormTemplate/models/FormStatus";
import { FormTemplateService } from "@/modules/FormTemplate/services/FormTemplateService";
import {
  FORMS_FILTERS_LIST,
  SERVICE_TEMP_CONSTANTS
} from "@/modules/ServiceTemplate/constants/ServiceTemplateConstants";
import CardAddForm from "@/shared/components/CardAddForm/CardAddForm.vue";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import FormModalViewer from "@/shared/components/FormModalViewer/FormModalViewer.vue";
import GenericSearchBar from "@/shared/components/GenericSearchBar/GenericSearchBar.vue";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import {
  GENERAL_CONSTANTS,
  NAME_FINDERS
} from "@/shared/constants/GeneralConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { QuerySend } from "@/shared/models/FormQuerySend";
import { Http } from "@status/codes";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import { ACTION_PLAN_CONSTANTS } from "../../constants/ActionPlanConstants";
import { ListaSelect } from "../../models/ActionPlan.model";
import { SourceInfo } from "./../../models/ActionPlan.model";
import { FormTemplateData } from "@/modules/FormTemplate/models/FormTemplateData";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";

@Component({
  name: "SourceData",
  components: {
    GenericSearchBar,
    CardAddForm,
    EmptyState,
    FormModalViewer,
    DynamicSelect
  }
})
export default class SourceData extends Vue {
  @Inject() formTemplateService!: FormTemplateService;

  @Prop() listData!: SourceInfo;
  @Prop() formTemplateArraySelect!: ListaSelect[];
  @Prop() groupInfoArraySelect!: ListaSelect[];
  @Prop() serviceTemplateSelect!: ListaSelect[];
  @Prop() loadingService!: boolean;
  @Prop() loadingGroups!: boolean;

  cardClass = STYLE_CLASSES.CARD_2;
  card2Class = STYLE_CLASSES.CARD_PADING;
  TITLES = ACTION_PLAN_CONSTANTS.TITLES;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  rowForms = STYLE_CLASSES.ROW_FORMS;

  formsFilterArray = FORMS_FILTERS_LIST;
  SEARCH_FORM_ACTION_PLAN_KEY = NAME_FINDERS.FORM_ACTION_PLAN;
  EMPTY_STATE_HEADER = FORM_MESSAGES.INFO_MESSAGE.NO_INFO_TO_SHOW;
  EMPTY_STATE_PARAGRAPH = FORM_MESSAGES.INFO_MESSAGE.EMPTY_STATE_TEXT;
  showCardsForm = false;
  lastFormRef = "";
  formsItems: QuerySend = {};

  rules = {
    service: [FORM_VALIDATORS.REQUIRED_FIELD, FORM_VALIDATORS.REQUIRED_ARRAY],
    formTemplate: [],
    infoGroup: []
  };

  serviceTemplateConfigList: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: this.serviceTemplateArrayListLocal.map(item => {
      return { id: item.key, name: item.name };
    }),
    messageLabel: this.TITLES.SELECT_SERVICE,
    required: true,
    chips: true,
    loadingData: this.loadingService,
    notFound: false
  };

  infoGroupConfigList: DynamicSelectConfig = {
    multiple: true,
    default: [],
    listAll: this.infoGroupArrayListLocal.map(item => {
      return { id: item.key, name: item.name };
    }),
    messageLabel: this.TITLES.SELECT_INFO_GROUP,
    required: false,
    loadingData: this.loadingGroups,
    chips: true
  };

  @Watch("loadingService")
  setLoadingService() {
    this.serviceTemplateConfigList.loadingData = this.loadingService;
  }

  @Watch("loadingGroups")
  setLoadingGroups() {
    this.infoGroupConfigList.loadingData = this.loadingGroups;
  }

  get serviceTemplateArrayListLocal() {
    return this.listData.serviceTemplate;
  }

  get infoGroupArrayListLocal() {
    return this.listData.infoGroup;
  }

  get formTemplateArrayLocal() {
    return this.formTemplateArraySelect;
  }

  set formTemplateArrayLocal(e: ListaSelect[]) {
    this.$emit("update:formTemplateArraySelect", e);
  }

  get groupInfoArrayLocal() {
    return this.groupInfoArraySelect;
  }

  set groupInfoArrayLocal(e: ListaSelect[]) {
    this.$emit("update:groupInfoArraySelect", e);
  }

  get serviceTemplateLocal() {
    return [
      {
        id: this.serviceTemplateSelect[0]?.key ?? "",
        name: this.serviceTemplateSelect[0]?.name ?? ""
      }
    ];
  }

  set serviceTemplateLocal(e: [{ id: string; name: string }]) {
    this.$emit("update:serviceTemplateSelect", [
      { key: e[0]?.id ?? "", name: e[0]?.name ?? "" }
    ]);
  }

  removeLabelFormTemplate(index: number) {
    this.formTemplateArrayLocal.splice(index, 1);
  }

  removeLabelInfoGroup(index: number) {
    this.groupInfoArrayLocal.splice(index, 1);
  }

  removeLabelServiceTemplate() {
    this.$emit("update:serviceTemplateSelect", []);
  }

  async getFormsFilterEvents(data: any) {
    delete data["mainFilterKey"];
    this.formsItems = data;
    this.lastFormRef = "";
    await this.searchTemplates(data, false);
  }

  loadingFomrData = false;
  formTempDataList: Array<FormStatus> = [];

  async searchTemplates(filterQueryForms: QuerySend, shouldPaginate?: boolean) {
    try {
      if (!shouldPaginate) this.loadingFomrData = true;

      const filterQueryFormsTemp: QuerySend = {
        state: FORM_CONSTANTS.STATE.ACTIVE,
        paginatedResult: true
      };
      if (filterQueryForms.name) {
        filterQueryFormsTemp.name = filterQueryForms.name[0];
      }
      if (filterQueryForms.category) {
        filterQueryFormsTemp.category = filterQueryForms.category[0];
      }
      if (this.lastFormRef) {
        filterQueryFormsTemp.docref = this.lastFormRef;
      }

      const formTempList = await this.formTemplateService.getFormTemplateWithFilters(
        filterQueryFormsTemp
      );

      if (formTempList.code === Http.Found && formTempList.data !== undefined) {
        const formList = formTempList.data.data;
        this.lastFormRef = formTempList.data.docref;
        this.showCardsForm = true;
        if (shouldPaginate) {
          this.formTempDataList = [...this.formTempDataList, ...formList];
        } else {
          this.formTempDataList = formList;
        }
      } else {
        if (!shouldPaginate) {
          this.formTempDataList = [];
          this.showCardsForm = false;
        }
        Snackbar.popError(formTempList.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${FORM_TEMPLATES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
    this.loadingFomrData = false;
  }

  viewFormTempDialog = false;
  formTemplateData: FormTemplateData = new FormTemplateData();
  dateCreated = "";
  dateModified = "";
  clearModel = false;
  async viewFormTemp(id: string) {
    try {
      const response = await this.formTemplateService.getFormTemplateSchemaById(
        id
      );

      if (response.code === Http.Found && response.data != null) {
        this.formTemplateData = response.data;

        this.dateCreated = this.formTemplateData.dateCreated
          ? new Date(this.formTemplateData.dateCreated).toLocaleString("es-CO")
          : "";

        this.dateModified = this.formTemplateData.dateChanged
          ? new Date(this.formTemplateData.dateChanged).toLocaleString("es-CO")
          : "";

        this.viewFormTempDialog = true;
        this.clearModel = true;
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${FORM_TEMPLATES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  closeModalPreview() {
    this.viewFormTempDialog = false;
  }

  addForm(form: FormStatus) {
    const newFormTemp: ListaSelect = { key: form._key, name: form.name };
    const existFormTemp = this.formTemplateArraySelect.find(
      formTemp => formTemp.key === newFormTemp.key
    );

    if (!existFormTemp) {
      this.formTemplateArraySelect.push(newFormTemp);
      return Snackbar.popSuccess(SERVICE_TEMP_CONSTANTS.MESSAGES.ADD_FORM);
    }
    return Snackbar.popInfo(SERVICE_TEMP_CONSTANTS.MESSAGES.EXIST_FORM);
  }

  removeForm(index: number) {
    this.formTemplateArraySelect.splice(index, 1);
  }

  fetchServiceTemplates(name?: string) {
    this.$emit(FORM_MESSAGES.FETCH_SERVICE_TEMPLATES, name);
  }

  fetchInfoGroups(name?: string) {
    this.$emit(FORM_MESSAGES.FETCH_INFO_GROUPS, name);
  }

  @Watch("listData", { deep: true })
  setList() {
    this.serviceTemplateConfigList.listAll = this.serviceTemplateArrayListLocal.map(
      item => {
        return { id: item.key, name: item.name };
      }
    );
    this.infoGroupConfigList.listAll = this.infoGroupArrayListLocal.map(
      item => {
        return { id: item.key, name: item.name };
      }
    );
  }
  async onBottomFormsScroll(e: any) {
    const { scrollTop, offsetHeight, scrollHeight } = e.target;
    if (scrollTop + offsetHeight >= scrollHeight - 1) {
      await this.searchTemplates(this.formsItems, true);
    }
  }
}
